import React, { useState} from 'react'
import MessageComponent from './Message'

interface ChatProps{
    title: string;
}


interface Message{
    author: string;
    content: string;
    isYours: boolean;
}

const messages: Message[] = [
    {
        author: 'BananaGuard',
        content: "Yours bananas are really good",
        isYours: false,
    },
    {
        author: "Maćko",
        content: "Lubie twoje makarony",
        isYours: false,
    },
    {
        author: "Programista Shoppy Live",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce condimentum vestibulum pretium. In nec erat accumsan, tempus magna accumsan, bibendum dolor. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam sit amet ultricies augue. Maecenas auctor ante a augue dictum, pharetra pharetra ipsum feugiat. Curabitur dapibus id ligula a facilisis. Quisque augue augue, porta et lorem ac, volutpat porta metus. Integer ut nisl vel odio sagittis vestibulum vitae sed augue. Aliquam in justo vitae ante varius bibendum pretium elementum ante. Praesent fringilla porta dui ultricies lacinia. Pellentesque dui mi, fringilla ac risus et, placerat pellentesque mi. Quisque ut lectus in risus tincidunt vehicula non et enim. Mauris ut sapien sem. Maecenas urna leo, tempor eget magna a, sodales facilisis justo.",
        isYours: true,
    },
    {
        author: "SugarBoy",
        content: "Etiam tempor sed eros sit amet congue. Phasellus quis ligula non purus euismod fringilla placerat vitae lectus. Nulla facilisi. Nullam scelerisque ut risus nec rhoncus. Sed vehicula iaculis auctor. Donec eget mi quis magna efficitur cursus quis non sem. In suscipit cursus lorem.",
        isYours: false,
    },
    {
        author: "Lorem Generator",
        content: "Proin a leo dignissim, commodo metus a, suscipit leo. Quisque posuere aliquam felis sit amet sodales. Donec sed sapien quis augue ultrices lacinia. Integer vehicula eros eros, a pellentesque arcu rutrum vitae. Mauris turpis velit, consequat et cursus efficitur, dignissim eu nisi. Suspendisse rhoncus tempus consectetur. Integer efficitur nunc vel sapien venenatis tristique sed eget nibh. Cras in diam semper, imperdiet diam nec, tincidunt risus. Proin sodales elementum ultrices. Vivamus tristique orci sed nulla posuere, eget aliquet lectus gravida. Duis aliquet erat eros, vel blandit urna dignissim ut. Nullam viverra sem nec turpis vehicula, ac iaculis nunc sollicitudin. Etiam sed tristique leo, quis porttitor tortor.",
        isYours: false,
    },




]

let renderedMessagesState = messages.map( message => <MessageComponent author={message.author} content={message.content} isYours={message.isYours}/>)



const Chat = (props: ChatProps) => {

    const [isShowed, setIsShowed] = useState(true);
    const [message, setMessage] = useState("");
    const [renderedMessages, setRenderedMessages] = useState(renderedMessagesState)

    const handleMessage = () => {
        const messageObj = {
            author: ' Programista Shoppy Live ',
            content: message,
            isYours: true
        }
        messages.push(messageObj);

         setRenderedMessages(messages.map( message => <MessageComponent author={message.author} content={message.content} isYours={message.isYours}/>))
         setMessage("");
    }


          if(isShowed){
              return(
                <div className="chat__container">
                    <div className="chat__header"> {props.title}
                        <button onClick={ () => { setIsShowed(state => !state) }} className="closeChat__button"> close </button>
                    </div>
                    <div className="chat__messages">
                        {renderedMessages}
                    </div>
                    <div className="write__message">
                            <textarea autoFocus placeholder="Here write your message" className="message__area"
                            onChange={ (e) => { setMessage(e.target.value) } }
                            >
                                {message}
                            </textarea>
                            <button className="form--button submit__message" onClick={ handleMessage}>send</button>
                    </div>
                </div>
              )
          }
          else{
              return(
                <button onClick={ () => { setIsShowed(state => !state) }} className="showChat__button">show chat</button>
              )
          }
}

export default Chat;